<template>
  <router-link :to="`/detail/${templateData.id}`" style="box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);" class="template template-mask-active">
    <img :src="`${templateData.small_img}?x-oss-process=image/resize,w_560,m_lfit`" class="template-img" alt="">
    <div class="template-mask">
      <h2 class="template-mask-title">{{ templateData.name }}</h2>
      <button class="template-mask-btn">立即下载</button>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'TemplateItem',
  props: {
    templateData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/styleMixins";
  .template{
    width: 280px;
    height: 316px;
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;
    transition: all .3s;
    &:hover{
      transform: scale(1.05);
    }
    &:hover > .template-mask{
      background-image: linear-gradient(180deg,rgba(0,0,0,.6) 0,transparent 20%,transparent 80%,rgba(0,0,0,.6));
      opacity: 1;
    }
    &-img{
      height: 100%;
      width: 100%;
      border-radius: 8px;
    }
    &-mask{
      border-radius: 8px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      transition: background-color,opacity .3s;
      opacity: 0;
      &-title{
        margin-top: 20px;
        text-align: center;
        color: white;
      }
      &-btn{
        .clear_button_default_mixins;
        border-width: 0;
        padding: 10px 30px;
        border-radius: 22px;
        background: linear-gradient(-90deg
          ,#3d6bff,#00b8f9);
        color: white;
        display: block;
        margin: 0 auto;
        margin-top: 200px;
      }
    }
  }
</style>
